import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { pathRoutingEnum } from 'src/assets/constantEnum';
import { DialogContentNewsLetter } from 'src/app/componenets/newsletter-dialog/dialog-content-newsletter';
import { ConsentService } from 'src/app/services/consent.service';
import { SocialLinksService } from 'src/app/services/social-links.service';

// Tuile du menu des services (barre du bas → Menu)
interface ServiceTile {
  labelKey: string;
  icon: string;
  link: string;
  queryParams?: Record<string, string>;
  tone: 'hot' | 'indigo' | 'teal' | 'pink' | 'neutral';
}

const DEAL_TILES: ServiceTile[] = [
  { labelKey: 'header.forYou', icon: 'local_offer', link: '/promotion', tone: 'hot' },
  { labelKey: 'header.promoCodes', icon: 'confirmation_number', link: '/promotionCode', tone: 'indigo' },
  { labelKey: 'nearby.nav', icon: 'near_me', link: '/pres-de-moi', tone: 'teal' },
  { labelKey: 'mobileHome.merchants', icon: 'storefront', link: '/advertisers', tone: 'pink' },
  { labelKey: 'mobileHome.favorites', icon: 'bookmark_border', link: '/compte/saved', tone: 'neutral' },
  { labelKey: 'deals.hotDeals', icon: 'local_fire_department', link: '/', tone: 'hot' },
];

const COMMUNITY_TILES: ServiceTile[] = [
  { labelKey: 'mobileHome.postLink', icon: 'add_link', link: '/poster', tone: 'hot' },
  { labelKey: 'inStore.badge', icon: 'add_a_photo', link: '/poster', queryParams: { mode: 'inStore' }, tone: 'teal' },
  { labelKey: 'header.clubPoints', icon: 'redeem', link: '/compte/club', tone: 'indigo' },
  { labelKey: 'mobileHome.messages', icon: 'forum', link: '/messages', tone: 'neutral' },
  { labelKey: 'mobileHome.contributions', icon: 'post_add', link: '/compte/contributions', tone: 'pink' },
  { labelKey: 'mobileHome.rewards', icon: 'emoji_events', link: '/compte/rewards', tone: 'indigo' },
];

@Component({
    selector: 'app-menu-mobile',
    templateUrl: './menu-mobile.component.html',
    styleUrls: ['./menu-mobile.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MenuMobileComponent implements OnInit {

  panelOpenState = false;
  readonly dealTiles = DEAL_TILES;
  readonly communityTiles = COMMUNITY_TILES;

  constructor(private router: Router, private consentService: ConsentService, private socialLinks: SocialLinksService,
    private dialog: MatDialog) { }

  // « Rejoignez-nous » : réseaux dont la page est renseignée dans le back office
  get socialLinks$() {
    return this.socialLinks.links$;
  }

  ngOnInit(): void {
  }

  onDashboard() {
    this.router.navigate([pathRoutingEnum.dashboard.valueOf()]);
  }

  onFilterCategory(dataForm: any) {
    this.redirectTo(pathRoutingEnum.category.valueOf() + '/' + dataForm)
  }

  redirectTo(uri: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri]));
  }

  showCookieDialog() {
    this.consentService.openPreferences();
  }

  // Même fenêtre d'inscription que l'icône e-mail du header desktop (sans compte)
  openNewsletter() {
    this.dialog.open(DialogContentNewsLetter, {
      width: '450px',
      data: { acceptNewsLetter: false, email: '' },
    }).afterClosed().subscribe(result => {
      localStorage.setItem('cookies_newsletter', result === false ? '0' : '1');
    });
  }

}
